import { DateRange } from 'owa-datetime-utils';
import { createDayGridScenario, highlightDayGridItem } from '../actions/dayGridActions';
import DayGridScenario from '../schema/DayGridScenario';
import getScenarioStore from '../selectors/getScenarioStore';
import getStore from '../store';
import tryUpdateFolderIdsAndSubscribeToNotifications from '../utils/tryUpdateFolderIdsAndSubscribeToNotifications';
import { KnownItemTypes } from 'owa-calendar-surface-dategrid';
import { OwaDate } from 'owa-datetime';
import { orchestrator } from 'satcheljs';
import { loadDayGrid, resetDayGridScenario, selectDayGridDate } from '../actions/publicActions';
import {
    initializeSchedulingGrid,
    navigateToDate,
    updateSelectionItem,
    convertToCalendarEvent,
    resetSchedulingGrid,
    updateFolderIds,
} from 'owa-calendar-scheduling-grid';

export const loadDayGridOrchestrator = orchestrator(
    loadDayGrid,
    async ({ scenario, initialDate, focusTimeDateRange, folderIds, highlightItemId }) => {
        // Explicitly update folderIds before consuming them. Otherwise the folderId for delegate calendar folder will not work.
        const updatedFolderIds = await tryUpdateFolderIdsAndSubscribeToNotifications(folderIds);

        loadDayGridInternal(
            scenario,
            initialDate,
            focusTimeDateRange,
            updatedFolderIds,
            highlightItemId
        );
    }
);

export const selectDayGridDateOrchestrator = orchestrator(
    selectDayGridDate,
    ({ scenario, newDate }) => {
        const store = getScenarioStore(scenario);
        if (store && store.schedulingGridViewState) {
            navigateToDate(store, newDate);
        }
    }
);

export const resetDayGridScenarioOrchestrator = orchestrator(
    resetDayGridScenario,
    ({ scenario }) => {
        const store = getScenarioStore(scenario);
        const lockId = store && store.schedulingGridViewState.eventsCacheLockId;
        resetSchedulingGrid(store, lockId);
        getStore().scenarios.delete(scenario);
    }
);

function loadDayGridInternal(
    scenario: DayGridScenario,
    initialDate: OwaDate,
    focusTimeDateRange: DateRange,
    updatedFolderIds: string[],
    highlightItemId: string
) {
    const store = getScenarioStore(scenario);

    const isScenarioGridInitialized = !!(store && store.schedulingGridViewState);
    const selectionItem = focusTimeDateRange
        ? convertToCalendarEvent(
              { Start: focusTimeDateRange.start, End: focusTimeDateRange.end },
              KnownItemTypes.suggestedItems
          )
        : null;
    if (isScenarioGridInitialized) {
        // if scenario exists, update date range and folderId to load events
        highlightDayGridItem(scenario, highlightItemId);
        navigateToDate(store, initialDate);
        updateFolderIds(store, updatedFolderIds);
        if (selectionItem) {
            updateSelectionItem(store, selectionItem);
        }
    } else {
        // if scenario hasn't been initialized, create scenario store and initialize scheduling grid
        createDayGridScenario(scenario);
        const store = getScenarioStore(scenario);
        highlightDayGridItem(scenario, highlightItemId);

        // initialize scheduling grid with valid folder id, so that events for that folder will be loaded
        initializeSchedulingGrid.importAndExecute(
            store,
            updatedFolderIds, // folderIds is present for Calendar Compose. In other scenarios, it is null until calendar cache is initialized. Scenarios should updateFolderIds in calendarCacheInitialized callback.
            initialDate,
            selectionItem, //selectionItem
            null, // filter items function,
            false, // show Free Busy
            false, // useFreeBusyForDefaultCalendar
            false // disableTabbableSurfaceItems
        );
    }
}
